import { render, staticRenderFns } from "./YzCheckbox.vue?vue&type=template&id=55765ccc&scoped=true&lang=pug&"
import script from "./YzCheckbox.vue?vue&type=script&lang=js&"
export * from "./YzCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./YzCheckbox.vue?vue&type=style&index=0&id=55765ccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55765ccc",
  null
  
)

export default component.exports